import React from 'react'
import styled from 'styled-components'

export type SelectOption<T extends string = string> = {
  value: T
  label: string
}

export const toSelectOption = <T extends string = string>(value: T) => ({
  value: value.toString(),
  label: value.toString(),
})

type Props<T extends string> = {
  selectedValue: T
  label?: string
  ariaLabel?: string
  options: SelectOption<T>[]
  onSelect: (_: T) => void
  disabled?: boolean
  name?: string
}

const StyledSelect = styled.select`
  padding: 10px;
  width: 100%;
`

const Select = <T extends string>({
  label,
  ariaLabel,
  selectedValue,
  onSelect,
  options,
  disabled,
  name,
}: Props<T>) => (
  <div>
    {label && <div>{label}</div>}
    <StyledSelect
      name={name}
      data-testid={`${name}-test`}
      aria-label={ariaLabel}
      value={selectedValue}
      onChange={e => onSelect(e.target.value as T)}
      disabled={disabled}
    >
      {options.map((option, i) => (
        <option key={i} value={option.value}>
          {option.label}
        </option>
      ))}
    </StyledSelect>
  </div>
)

export default Select
